import swaggerClient, {config} from '../../utility/swaggerClient';
import swaggerProjectClient from '../../utility/swaggerProjectClient'

export const projectsList = async (jobtype, customerid) => {
  const params = { jobtype, customerid};
  const client = await swaggerClient();
  console.log(client.apis);
  const response = (await client.apis.projectsList.get_user_projects__jobtype___customerid_(
    {
      ...params
    }
  )).body;
  return response;
};

export const filesList = async (groupId,customerid) => {
  const params = { groupId ,customerid};
  const client = await swaggerClient();
  console.log(client.apis);
  const response = (await client.apis.filesList.get_shift_files__customerid___groupId_(
    {
      ...params
    }
  )).body;
  return response;
};

export const checkfree = async (username) => {
  const params = { username };
  const client = await swaggerClient();
  console.log(client.apis);
  const response = (await client.apis.checkfree.get_user_assessment_checkFree({})).body;
  return response;
};

export const deletesrccode = async (customerid,projectname) => {
  const params = { customerid,projectname};
  const client = await swaggerClient();
  console.log(client.apis);
  const response = (await client.apis.deletesrccode.delete_user_delete__customerid___projectname_(
    {
      ...params
    }
  )).body;
  return response;
};

export const customersList = async () => {
  const client = await swaggerClient();
  const response = (await client.apis.customersList.get_shift_customers()).body;
  return response;
};

export const alldfList = async () => {
  
  const client = await swaggerClient();
  console.log(client.apis);
  const response = (await client.apis.alldfList.get_datafactory_alldfs()).body;
  return response;
};

export const checkddlexist = async (customerid, projectname,page) => {
  const params = { customerid, projectname,page};
  const client = await swaggerClient();
  console.log(client.apis);
  const response = (await client.apis.checkddlexist.get_user_checkddlexist__customerid___projectname___page_(
    {
      ...params
    }
  )).body;
  return response;
};

export const checkddlexistjdbc = async (customerid, projectname,jdbc) => {
  const params = { customerid, projectname,jdbc};
  const client = await swaggerClient();
  console.log(client.apis);
  const response = (await client.apis.checkddlexistjdbc.get_user_checkddlexistjdbc__customerid___projectname___jdbc_(
    {
      ...params
    }
  )).body;
  return response;
};

export const checkexistunitest = async (projectId) => {
  const params = { projectId};
  const client = await swaggerClient();
  console.log(client.apis);
  const response = (await client.apis.checkexistunitest.get_fuse_checkexistunitest__projectId_(
    {
      ...params
    }
  )).body;
  return response;
};


export const customerdfList = async (customerid) => {
  const params = { customerid};
  const client = await swaggerClient();
  console.log(client.apis);
  const response = (await client.apis.customerdfList.get_user_dfs__customerid_(
    {
      ...params
    }
  )).body;
  return response;
};


export const customersPrjList = async (jobtype,customerid) => {
  const params = { jobtype, customerid};
  const client = await swaggerClient();
  console.log(client.apis);
  const response = (await client.apis.projectsList.get_user_projects__jobtype___customerid_(
    {
      ...params
    }
  )).body;
  return response;
};



export const checkdfname = async (repo,customerid) => {
  const params = { repo,customerid};
  const client = await swaggerClient();
  console.log(client.apis);
  const response = (await client.apis.checkdfname.get_user_checkdfname__repo___customerid_(
    {
      ...params
    }
  )).body;
  return response;
};

export const customersPrjList_Tran = async (jobtype,customerid) => {
  const params = { jobtype,customerid};
  const client = await swaggerClient();
  const response = (await client.apis.projectsList.get_user_projects__jobtype___customerid_(
    {
      ...params
    }
  )).body;
  return response;
};

export const stagingPrjList = async (jobtype,repo,customerid) => {
  const params = { jobtype,repo,customerid};
  const client = await swaggerClient();
  console.log(client.apis);
  const response = (await client.apis.getStagingProjects.get_user_getStagingProjects__jobtype___repo___customerid_(
    {
      ...params
    }
  )).body;
  return response;
};

export const gettranslationstagingforrelease = async (jobtype,repo,customerid) => {
  const params = { jobtype,repo,customerid};
  const client = await swaggerClient();
  console.log(client.apis);
  const response = (await client.apis.gettranslationstagingforrelease.get_user_getstagingforrelease__jobtype___repo___customerid_(
    {
      ...params
    }
  )).body;
  return response;
};

export const usersList = async (username) => {
  const params = {username};
  const client = await swaggerClient();
  const response = (await client.apis.GetUsersList.get_user_userlist__username_(
    {
      ...params
    }
  )).body;
  return response;
};

export const dfusersList = async (dfname) => {
  const params = {dfname};
  const client = await swaggerClient();
  console.log(client.apis);
  const response = (await client.apis.dfusersList.get_user_dfuserlist__dfname_(
    {
      ...params
    }
  )).body;
  return response;
};

export const addusertodf = async (userid,dfid) => {
  const params = {userid,dfid};
  const client = await swaggerClient();
  console.log(client.apis);
  const response = (await client.apis.addusertodf.get_user_addusertodf__userid___dfid_(
    {
      ...params
    }
  )).body;
  return response;
};

export const removeusertodf = async (userid,dfid) => {
  const params = {userid,dfid};
  const client = await swaggerClient();
  console.log(client.apis);
  const response = (await client.apis.removeusertodf.get_user_removeusertodf__userid___dfid_(
    {
      ...params
    }
  )).body;
  return response;
};

export const delgetdfusersList = async (dfuserid,dfid) => {
  const params = {dfuserid,dfid};
  const client = await swaggerClient();
  console.log(client.apis);
  const response = (await client.apis.delgetdfusersList.get_user_delgetdfuserlist__dfuserid___dfid_(
    {
      ...params
    }
  )).body;
  return response;
};

export const getuserlistnotindf = async (customerid,dfid) => {
  const params = {customerid,dfid};
  const client = await swaggerClient();
  console.log(client.apis);
  const response = (await client.apis.getuserlistnotindf.get_user_userlistnotindf__customerid___dfid_(
    {
      ...params
    }
  )).body;
  return response;
};

export const changeowner = async (newownerid,newownername,dfid) => {
  const params = {newownerid,newownername,dfid};
  const client = await swaggerClient();
  console.log(client.apis);
  const response = (await client.apis.changeowner.get_user_changeowner__newownerid___newownername___dfid_(
    {
      ...params
    }
  )).body;
  return response;
};

export const changeAdmin = async (oldAdmin,newAdmin) => {
  const params = {oldAdmin,newAdmin};
  const client = await swaggerClient();
  console.log(client.apis);
  const response = (await client.apis.changeadmin.put_user_changeadmin(
    {
      changeadmin: {
        oldAdmin,
        newAdmin
      }
    }
  )).body;
  return response;
};

export const usersapproveList = async (username) => {
  const params = {username};
  const client = await swaggerClient();
  console.log(client.apis);
  const response = (await client.apis.usersapproveList.get_shift_customersinfo(
    {
      ...params
    }
  )).body;
  return response;
};

export const customerApprove = async (id) => {
  const params = {id};
  const client = await swaggerClient();
  console.log(client.apis);
  const response = (await client.apis.customerApprove.post_user_customerApprove(
    {
      customerApprove:{
        id
      }
    }
  )).body;
  return response;
};

export const customerdeactivate = async (id) => {
  const params = {id};
  const client = await swaggerClient();
  console.log(id)
  console.log(client.apis);

  const response = (await client.apis.customerdeactivate.post_user_customerdeactivate(
    {
      customer:{
        id
      }
    }
  )).body;
  return response;
};

export const customerrectivate = async (id) => {
  const params = {id};
  const client = await swaggerClient();
  console.log(client.apis);
  const response = (await client.apis.customerrectivate.post_user_customerreactivate(
    {
      customer:{
        id
      }
    }
  )).body;
  return response;
};

export const languagecombo = async () => {
  // const params = {id};
  const client = await swaggerClient();
  console.log(client.apis);
  const response = (await client.apis.languagecombo.get_shift_language(
    {}
  )).body;
  return response;
};

export const RequestList = async (username) => {
  const params = {username};
  const client = await swaggerClient();
  const response = (await client.apis.gettransactions.get_shift_requestList__username_(
    {
      ...params
    }
  )).body;
  return response;
};

export const NPRequestList = async (customer) => {
  const params = {customer};
  const client = await swaggerClient();
  console.log(client.apis);
  const response = (await client.apis.gettransactions.get_shift_customerrequestlist__customer_(
    {
      ...params
    }
  )).body;
  return response;
};

export const customerexist = async (contactEmail) => {
  const params = {contactEmail};
  const client = await swaggerClient();
  console.log(client.apis);
  console.log(client.apis.customerexist);
  const response = (await client.apis.customerexist.post_shift_customerexist({
    customerexist: {
      contactEmail
    }
  })).body;
  return response;
};

export const downloadPrj = async (customerid,projectname) => {
  const params = {customerid,projectname};
  const client = await swaggerClient();
  console.log(client.apis);
  const response = (await client.apis.downloadprj.get_user_download__customerid___projectname_(
    {
      ...params
    }
  )).body;
  return response;
};

export const projectsListForApproveTranslation = async (jobtype, groupId, creatorid) => {
  const params = { jobtype, groupId, creatorid };
  const client = await swaggerClient();

  const response = (await client.apis.gitlabprojectsforapprovetranslation.get_gitlabprojectsforapprovetranslation__jobtype___groupId___creatorid_(
    {
      ...params
    }
  )).body;
  return response;
};

export const assessment = async (
  username,
  reponame,
  srclang,
  tgtlang,
  description,
  jobType,
  reponamefordataen,
  customerid,
  projectname
) => {
  const client = await swaggerClient();
  //console.log('assessment client.apis:  ');
  console.log(client.apis);
  const response = (await client.apis.assessment.post_user_analyzerworkingassessment({
    assessmentInfo: {
      username,
      reponame,
      srclang,
      tgtlang,
      description,
      jobType,
      reponamefordataen,
      customerid,
      projectname
    }
  })).body;
  return response;
};

export const translationworking = async (
  username,
  reponame,
  srclang,
  tgtlang,
  description,
  jobType,
  reponamefordataen,
  customerid,
  projectname,
) => {
  const client = await swaggerClient();
  //console.log('assessment client.apis:  ');
  console.log(client.apis);
  const response = (await client.apis.translationworking.post_user_translationworking({
    assessmentInfo: {
      username,
      reponame,
      srclang,
      tgtlang,
      description,
      jobType,
      reponamefordataen,
      customerid,
      projectname,
    }
  })).body;
  return response;
};

export const createupdatedf = async (
  customerid,
  username,
  dfid,
  dfTypeName,
  reponame,
  srclang,
  tgtlang,
  hive,
  hadoop,
  jdbclistcopyy,
  // customerid,
  // projectname,
) => {
  const client = await swaggerClient();
  //console.log('assessment client.apis:  ');
  console.log(client.apis);
  const response = (await client.apis.createupdatedf.post_user_createupdatedf({
    assessmentInfo: {
      customerid,
      username,
      dfid,
      dfTypeName,
      reponame,
      srclang,
      tgtlang,
      hive,
      hadoop,
      jdbclistcopyy,
      // customerid,
      // projectname,
    }
  })).body;
  return response;
};


export const userRequest = async (
  username,
  reponame,
  srclang,
  tgtlang,
  description,
  jobType,
  customerid
) => {

  const client = await swaggerClient();
  console.log(client.apis);
  const response = (await client.apis.userRequest.post_user_submitusertransaction__customerid_({
    assessmentInfo: {
      username,
      reponame,
      srclang,
      tgtlang,
      description,
      jobType
    },
    customerid
  })).body;
  return response;
};

export const assessmentfordatasubmit = async (
  reponamefordataen,
  reponame,
  srclang,
  tgtlang,
  description,
  opportunity_num,
  clientname,
  username,
  name,
  customerid,
  projectname
) => {
  const client = await swaggerClient();
  //console.log('assessment client.apis:  ');
  console.log(client.apis);
  const response = (await client.apis.assessmentfordatasubmit.post_analyzerworkingassessment({
    assessmentInfo: {
      reponamefordataen,
      reponame,
      srclang,
      tgtlang,
      description,
      opportunity_num,
      clientname,
      username,
      name,
      customerid,
      projectname
    }
  })).body;
  return response;
};


export const translation = async (
  reponame,
  srclang,
  tgtlang,
  description,
  financialforce_id,
  clientname,
  username,
  name
) => {
  const client = await swaggerClient();
  //console.log('assessment client.apis:  ');
  //console.log(client.apis.assessment);
  const response = (await client.apis.translation.post_translation({
    assessmentInfo: {
      reponame,
      srclang,
      tgtlang,
      description,
      financialforce_id,
      clientname,
      username,
      name
    }
  })).body;
  return response;
};

export const placeorder = async ( reference_id,quotation_id,username) => {
  const client = await swaggerClient();

  console.log(client.apis.placeorder);
  const response = (await client.apis.placeorder.post_placeorder(
    {
      translationInfo: {
        reference_id,
        quotation_id,
        username

      }
    }
  )).body;
  return response;
};


export const approvetranslation = async (username,reponame,srclang,tglang,description,jobType,reponamefordataen,customerid,reference_id) => {
  const client = await swaggerClient();
  console.log('translation client.apis:  ');
  console.log(client.apis);
  const response = (await client.apis.approvetranslation.post_user_approvetranslation(
    {
      translationInfo: {
        username,reponame,srclang,tglang,description,jobType,reponamefordataen,customerid,reference_id
      }
    }
  )).body;
  return response;
};

export const approveassessment = async (username,reponame,srclang,tglang,description,jobType,reponamefordataen,customerid,reference_id) => {
  const client = await swaggerClient();
  console.log('translation client.apis:  ');
  console.log(client.apis);
  const response = (await client.apis.approveassessment.post_user_approveassessment(
    {
      translationInfo: {
        username,reponame,srclang,tglang,description,jobType,reponamefordataen,customerid,reference_id
      }
    }
  )).body;
  return response;
};



export const emailValidation = async email => {
  const params = { email };
  const client = await swaggerClient();
  //console.log('client.apis:  ');
  //console.log(client.apis.emailValidation);
  const response = (await client.apis.emailValidation.get_emailValidation__email_(
    {
      ...params
    }
  )).body;
  return response;
};

export const updatePassword = async (gitlabid, username) => {
  const params = { gitlabid, username };
  const client = await swaggerClient();
  //console.log('client.apis:  ');
  //console.log(client.apis.updatePassword);
  const response = (await client.apis.updatePassword.put_updatePassword({
    ...params
  })).body;
  return response;
};

export const getuser = async username => {
  const params = { username };
  const client = await swaggerClient();
  console.log('client.apis:  ');
  console.log(client.apis.getuser);
  const response = (await client.apis.getuser.get__username_({
    ...params
  })).body;
  return response;
};

export const reject = async username => {
  const params = { username };
  const client = await swaggerClient();
  console.log('client.apis:  ');
  console.log(client.apis.reject);
  const response = (await client.apis.reject.get_rejection__username_({
    ...params
  })).body;
  return response;
};

export const forgetpassword = async email => {
  const params = { email };
  const client = await swaggerClient();
  //console.log('client.apis:  ');
  //console.log(client.apis.forgetpassword);
  const response = (await client.apis.forgetpassword.get_user_forgetpassword__email_(
    {
      ...params
    }
  )).body;
  return response;
};

export const changepassword = async (username,password,newpassword) => {
  const params = { username,password,newpassword};
  const client = await swaggerClient();
  //console.log('client.apis:  ');
  const response = (await client.apis.changepassword.post_user_changepassword(
    {
      "user": {
        username,
        password,
        "newPassword" : newpassword
      }
    }
  )).body;
  return response;
};

export const getreferenceidlist = async reponame => {
  const params = { reponame };
  const client = await swaggerClient();
  console.log('client.apis:  ');
  console.log(client.apis.getreferenceidlist);
  const response = (await client.apis.getreferenceidlist.get_getreferenceidbyrepo__reponame_(
    {
      ...params
    }
  )).body;
  return response;
};

export const resolveToken = async token => {
  const encodeToken = encodeURIComponent(token);
  const params = { token, encodeToken};
  const client = await swaggerClient();
  console.log(client.apis);
  const response = (await client.apis.resolveToken.post_marketplace_resolve_x_amzn_marketplace_token__token_(
    {
      ...params
    }
  )).body;
  return response;
};

export const getinfobyreferenceid = async reference_id => {
  const params = { reference_id };
  const client = await swaggerClient();
  console.log('client.apis:  ');
  console.log(client.apis.getinfobyreferenceid);
  const response = (await client.apis.getinfobyreferenceid.get_getinfobyreferenceid__reference_id_(
    {
      ...params
    }
  )).body;
  return response;
};

export const getquotbypo = async quotation_id => {
  const params = { quotation_id };
  const client = await swaggerClient();
  console.log('client.apis:  ');
  console.log(client.apis.getquotbypo);
  const response = (await client.apis.getquotbypo.get_getquotbypo__quotation_id_(
    {
      ...params
    }
  )).body;
  return response;
};


export const getinfobyreferenceidforquo = async reference_id => {
  const params = { reference_id };
  const client = await swaggerClient();
  console.log('client.apis:  ');

  const response = (await client.apis.getinfobyreferenceidforquo.get_getinfobyreferenceidforquo__reference_id_(
    {
      ...params
    }
  )).body;
  return response;
};

export const getinfobyusernameandreferenceid = async (username, reference_id) => {
  const params = {username,reference_id };
  const client = await swaggerClient();
  console.log(username);
  console.log(reference_id);
  //console.log(client.apis.getinfobyusernameandreferenceid);
  console.log(client.apis);
  const response = (await client.apis.getinfobyusernameandreferenceid.get_getinfobyusernamewithreferenceid__username___reference_id_(
    {
      ...params
    }
  )).body;
  return response;
};

export const downloadRpt = async reference_id => {
  const params = { reference_id };
  const client = await swaggerClient();
  console.log('client.apis:  ');
  console.log(client.apis.downloadRpt);
  const response = await client.apis.downloadRpt.get_reports__reference_id_({
    ...params
  });
  return response;
};

export const transdownloadRpt = async reference_id => {
  const params = { reference_id };
  const client = await swaggerClient();
  console.log('client.apis:  ');
  console.log(client.apis.transdownloadRpt);
  const response = await client.apis.transdownloadRpt.get_transreports__reference_id_({
    ...params
  });
  return response;
};


export const getinfobyponumber = async po_num => {
  const params = { po_num };
  const client = await swaggerClient();
  console.log('client.apis:  ');
  console.log(client.apis.getinfobyponumber);
  const response = (await client.apis.getinfobyponumber.get_getinfobyponumber__po_num_(
    {
      ...params
    }
  )).body;
  return response;
};

export const getinfobyreponame = async (reponame,customerid,jobtype) => {
  const params = { jobtype,reponame,customerid};
  const client = await swaggerClient();
  console.log('client.apis:  ');
  console.log(client.apis);
  const response = (await client.apis.getinfobyreponame.get_user_getinfobyreponame__jobtype___reponame___customerid_(
    {
      ...params
    }
  )).body;
  return response;
};

export const gensourcetest = async (factoryName,mappingName,factoryId,projectId,commands) => {
  console.log(commands);
  const params = { factoryName,mappingName,factoryId,projectId,commands};
  const client = await swaggerClient();
  console.log('client.apis:  ');
  console.log(client.apis);
  const response = (await client.apis.jenkins.get_jenkins__factoryName___mappingName___factoryId___projectId__commands__commands_(
    {
      ...params
    }
  )).body;
  return response;
};

export const getinfobyreponameforaccessment = async (reponame,customerid) => {
  const params = { reponame,customerid};
  const client = await swaggerClient();
  console.log(client.apis);
  const response = (await client.apis.getinfobyreponameforaccessment.get_user_getinfobyreponameforaccessment__reponame___customerid_(
    {
      ...params
    }
  )).body;
  return response;
};


export const approve = async (username, email, name, role) => {
  //const params = { username, email, name, role };
  const client = await swaggerClient();
  console.log('client.apis:  ');
  console.log(client.apis.approveuser);
  const response = (await client.apis.approveuser.post_approveUser({
    userinfo: {
      username,
      email,
      name,
      role
    }
  })).body;
  return response;
};

export const sendfinalapprove = async (username, email, name, role) => {
  //const params = { username, email, name, role };
  const client = await swaggerClient();
  console.log('client.apis:  ');
  console.log(client.apis.sendfinalapprove);
  const response = (await client.apis.sendfinalapprove.post_sendfinalapprove({
    userinfo: {
      username,
      email,
      name,
      role
    }
  })).body;
  return response;
};

export const contactus = async ( firstNameAndLastName,
                                 companyName,
                                 corporateEmail,
                                 message) => {
  const client = await swaggerClient();
  console.log(client.apis);
  const response = (await client.apis.contactus.post_sendfinalapprove({
    userinfo: {
      firstNameAndLastName,
      companyName,
      corporateEmail,
      message
    }
  })).body;
  return response;
};

export const customerregister = async (
  companyName,
  companyAlias,
  contactFirstName,
  contactLastName,
  contactEmail,
  contactPhoneNumber,
  adminFirstName,
  adminLastName,
  adminEmail,
  adminPhoneNumber
) => {
  //const params = { username, email, name, role };
  const client = await swaggerClient();
  console.log('client.apis:  ');
  console.log(client.apis);
  const response = (await client.apis.customerregister.post_user_customerregister({
    customer: {
      companyName,
      companyAlias,
      contactFirstName,
      contactLastName,
      contactEmail,
      contactPhoneNumber,
      adminFirstName,
      adminLastName,
      adminEmail,
      adminPhoneNumber
    }
  })).body;
  return response;
};

export const register = async (firstName, lastName, email, phoneNumber,adminUsername,role,customerid) => {
  const client = await swaggerClient();
  //console.log(username + email + password + telephone);
  const response = (await client.apis.register.post_user_register({
    register: {
      firstName,
      lastName,
      email,
      phoneNumber,
      adminUsername,
      role,
      customerid
    }
  })).body;

  return response;
};

export const unregister = async (username, email, adminUsername) => {
  const client = await swaggerClient();
  //console.log(username + email + password + telephone);
  // console.log(client.apis);
  const response = (await client.apis.unregister.post_user_unregister({
    unregister: {
      username,
      email,
      adminUsername
    }
  })).body;

  return response;
};


export const reactiveUser = async (username, email, adminUsername) => {
  const params = { username, email, adminUsername};
  const client = await swaggerClient();
  console.log(client.apis);
  const response = (await client.apis.reactiveUser.post_user_reactive(
    {
      reactive: {
        username,
        email,
        adminUsername
      }
    }
  )).body;
  return response;
};



// WEBPACK FOOTER //
// ./src/state/assessment/api.js